import {DocumentNode} from 'graphql';
import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const REQUEST_V2_DEFINITION_FILE_STATE_QUERY: DocumentNode = gql`
  query RequestV2DefinitionFileStateQuery($fileId: StrictString!) @skipAudit @engComponent(name: WORKFLOWS) {
    requestV2Definition(id: $fileId) {
      ... on RequestV2DefinitionNode {
        id
        name
        editUrl
        templateDocument {
          id
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
